import 'slick-carousel';

$(".top-projects-slides").slick({
  dots: true,
  arrows: true,
  fade: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  //variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4500,
  speed: 1500,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        fade: false,
        centerMode: true,
        variableWidth: true
      }
    }
  ]
})

$(".component-slides").slick({
  dots: true,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  //variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 3800,
  speed: 800
})

$(".othercontents-sides").slick({
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2,
        autoplay: true
      }
    }
  ]
})

